export default __webpack_public_path__ + "static/media/Logo_Castle_Rock_Blanco.cfe69b12.png";